import React, {useState} from 'react';
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import "react-datepicker/dist/react-datepicker.css";
import * as CryptoJS from "crypto-js";
import {
    checkFinalizeDinNo,
    getBuyerList,
    getBuyerList1,
    getBuyerQuotedPrice, getBuyerQuotedPriceSingle,
    getDinNoTagList,
    saveFinalisedDeal
} from "../../../services/disposal.service";
import {useLocation, useNavigate} from 'react-router-dom';


function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}

function SingleFinalizeDeal() {
    const location = useLocation();
    const [items, setItems] = useState([]);

    const [activeTab, setActiveTab] = useState(0);

    const [formSubmitted, setFormSubmitted] = useState(false);

    const [success, setSuccess] = useState(false);

    const [errMsg, setErrMsg] = useState('');

    const [dinno, setDinno] = useState('');
    const [dinnoError, setdinNoError] = useState('');

    const [finalSalePrice, setFinalSalePrice] = useState('');
    const [finalSalePriceError, setFinalSalePriceError] = useState('');

    const [quotedReceivedDate, setQuotedReceivedDate] = useState('');
    const [quotedReceivedDateError, setQuotedReceivedDateError] = useState('');

    const [finalApprovalDate, setFinalApprovalDate] = useState('');
    const [finalApprovalDateError, setFinalApprovalDateError] = useState('');

    const [finalApprovalBy, setFinalApprovalBy] = useState('');
    const [finalApprovalByError, setFinalApprovalByError] = useState('');

    const [selectedBuyer, setSelectedBuyer] = useState('');

    const [disposal, setDisposal] = useState('');
    const [ErrDisposal, setErrDisposal] = useState(false);

    const [dealPriceType, setDealPriceType] = useState('');
    const [ErrDealPriceType, setErrDealPriceType] = useState(false);

    const [assetInfo, setAssetInfo] = useState({});
    const [tagList, setTagList] = useState({});
    const [tagSubStatus, setTagSubStatus] = useState({});

    const [buyer, setBuyer] = useState('');
    const [setbuyer, buyerError] = useState('');

    const [buyer_no, setBuyerNo] = useState('');
    const [buyerNameOptions, setBuyerNameOptions] = useState([])
    const [ErrBuyerNameOptions, setErrBuyerNameOptions] = useState(false);

    const [isFinalized, setIsFinalized] = useState(false); // Tracks if the DIN is finalized

    const updatedDinNo = assetInfo.din_no ? `${assetInfo.din_no}-F` : '';

    const [selectedTagList, setSelectedTagList] = useState([]);

    const [salePrices, setSalePrices] = useState({});
    const [salePriceErrors, setSalePriceErrors] = useState({});

    const [quotedPrices, setQuotedPrices] = useState({});

    const [selectedTags, setSelectedTags] = useState([]);

    const handleSalePriceChange = (tag, value) => {
        setSalePrices(prev => ({ ...prev, [tag]: value }));

        // Validation: Ensure it's a positive number with up to 2 decimal places
        if (!value || isNaN(value) || Number(value) <= 0) {
            setSalePriceErrors(prev => ({ ...prev, [tag]: "Final sale price is required and must be a positive number." }));
        } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
            setSalePriceErrors(prev => ({ ...prev, [tag]: "Enter a valid numeric value (up to 2 decimal places)." }));
        } else {
            setSalePriceErrors(prev => ({ ...prev, [tag]: "" }));
        }
    };

    // Check if all tags have status "Sale Completed"
    const allTagsFinalized = tagList.length > 0 && tagList.every(({sub_status}) => sub_status === "Sale Completed");

    const navigate = useNavigate();

    const handleBuyerDetails = async (e) => {
        const selectedName = e.target.value;

        if (selectedName === "") {
            setSelectedBuyer("");
            setBuyerNo("");
            setBuyer("");
            setQuotedPrices({}); // Reset quoted prices
            return;
        }

        const selectedBuyerObj = buyerNameOptions.find(buyer => buyer.buyer_name === selectedName);

        if (selectedBuyerObj) {
            setSelectedBuyer(selectedBuyerObj.buyer_name);
            setBuyerNo(selectedBuyerObj.buyer_no);
            fetchBuyerQuotedPrice(selectedBuyerObj.buyer_name);

            // Ensure previous prices are cleared
            setQuotedPrices({});

            // Fetch quoted prices for all selected tags
            await Promise.all(selectedTags.map(tag => fetchBuyerQuotedPriceSingle(tag, selectedBuyerObj.buyer_name)));

            // Log final state
            //console.log("Final quotedPrices state:", quotedPrices);
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        let valid_Name = true;

        // Validate DIN number
        if (!(dinno) && dinno !== 0) {
            setdinNoError('DIN no is required');
            valid_Name = false;
        } else {
            setdinNoError('');
        }

        // Validate Disposal Type
        if (!(disposal) && disposal !== 0) {
            setErrDisposal('Select type of finalization required');
            valid_Name = false;
        } else {
            setErrDisposal('');
        }
        // Validate Deal Price Type (only if disposal is Full)
        if (disposal === "Full" && !dealPriceType) {
            setErrDealPriceType("Select type of Deal Price");
            valid_Name = false;
        } else {
            setErrDealPriceType("");
        }

        if (valid_Name) {
            //handleFormSubmit1(e);
            handleNextClick();
        } else {
            return false;
        }
    };

    const handleFormSubmit1 = (e) => {
        e.preventDefault();
        let valid_Name = true;
        let updatedSelectedTags = selectedTags;

        if (disposal === "Partial") {
            if (selectedTags.length === 0) {
                //console.log("Validation Failed: No selected tags for Partial disposal");
                setErrMsg('At least one tag must be selected for Partial disposal.');
                valid_Name = false;
            } else {
                setErrMsg('');
            }
        } else if (disposal === "Full") {
            // Select all tags for Full disposal
            updatedSelectedTags = tagList.map(({ tag }) => tag);
            setSelectedTags(updatedSelectedTags);  // Update selected tags correctly

            if (updatedSelectedTags.length === 0) {
                //console.log("Validation Failed: No tags found for Full disposal");
                setErrMsg('No tags available for Full disposal.');
                valid_Name = false;
            } else {
                setErrMsg('');
            }

            // Check if all tags have "No Quote Received"
            const someNoQuotes = tagList.some(({ buyerCount }) => buyerCount === 0);
            if (someNoQuotes) {
                //console.log("Validation Failed: Some selected tags have 'No Quote Received'");
                setErrMsg('Some selected TAGs have not received a quote.');
                valid_Name = false;
            }
        }

        if (!valid_Name) {
            //console.log("Form submission blocked due to validation failure");
            return false;
        }

        // Encrypt and submit data
        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'din_no': dinno, 'tags': updatedSelectedTags },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        const oData = { 'token': EncryptData };

        getBuyerList(oData).then((res) => {
            try {
                if (res?.data?.data?.res && Array.isArray(res.data.data.res)) {
                    if (res.data.data.res.length === 0) {
                        //console.log("No buyers found, setting error message.");
                        setBuyerNameOptions([]);
                        setErrMsg('No buyers found for selected tags.');
                        return;
                    }

                    const uniqueBuyersSet = new Set();
                    const uniqueBuyers = res.data.data.res.filter(item => {
                        const buyerNameNormalized = item.buyer_name.trim().toLowerCase();
                        if (!uniqueBuyersSet.has(buyerNameNormalized)) {
                            uniqueBuyersSet.add(buyerNameNormalized);
                            return true;
                        }
                        return false;
                    });

                    setBuyerNameOptions(prev => {
                        const prevBuyerNames = prev.map(item => item.buyer_name.toLowerCase());
                        const newBuyerNames = uniqueBuyers.map(item => item.buyer_name.toLowerCase());

                        if (JSON.stringify(prevBuyerNames) !== JSON.stringify(newBuyerNames)) {
                            return uniqueBuyers;
                        }
                        return prev;
                    });

                    setErrMsg('');
                } else {
                    //console.log("Invalid API response, setting error message.");
                    setBuyerNameOptions([]);
                    setErrMsg('No buyers found for selected tags.');
                }
            } catch (error) {
                console.error('Error processing buyer list:', error);
                setBuyerNameOptions([]);
                setErrMsg('Error processing buyer list');
            }
        }).catch((error) => {
            console.error('Error fetching buyer list:', error);
            setBuyerNameOptions([]);
            setErrMsg('Error fetching buyer list');
        });

        //console.log("Proceeding to next step");
        handleNextClick();
    };

    const handleNextClick = () => {
        // Handle the "Next" button click to move to the next tab
        setActiveTab(activeTab + 1);
    };

    const resetAssetDisposalInfo = function () {
        setDinno('');
    }

    const getTagInfo = function () {
        if (!(dinno) && dinno !== 0) {
            setdinNoError('DIN no is required');
        } else {
            setdinNoError('');

            const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'din_no': dinno},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            const oData = {'token': EncryptData};

            getDinNoTagList(oData).then(function (res) {
                if (res?.data?.tag_data && Array.isArray(res.data.tag_data)) {
                    // Merge buyerCount with tag_data
                    const mergedTagList = res.data.tag_data.map(tagItem => {
                        const buyerData = res.data.buyerCount.find(buyer => buyer.tag === tagItem.tag);
                        return {
                            ...tagItem,
                            buyerCount: buyerData ? buyerData.count : 0 // Default to 0 if not found
                        };
                    });

                    setTagList(mergedTagList); // Set the merged data in state
                    setErrMsg('');
                } else {
                    setTagList([]); // Clear the list if no data
                    setErrMsg('Din no TAG Not found');
                }
            });

            checkFinalizeDinNo(oData).then(function (res) {
                if (res?.data?.data?.res && res.data.data.res.length > 0) {
                    const data = res.data.data.res[0];
                    setErrMsg('');
                    setAssetInfo(data);
                    setBuyerNameOptions(res.data.data.res);


                    // Automatically select first buyer and fetch quoted price
                    if (res.data.data.res.length > 0) {
                        const firstBuyer = res.data.data.res[0];
                        setSelectedBuyer(firstBuyer.buyer_name);
                        setBuyerNo(firstBuyer.buyer_no);
                        fetchBuyerQuotedPrice(firstBuyer.buyer_name);
                        setFinalSalePrice(firstBuyer.buyer_final_price);
                        setFinalApprovalBy(firstBuyer.final_approval_by);
                        setQuotedReceivedDate(new Date(firstBuyer.buyer_quote_received_date));
                        setFinalApprovalDate(new Date(firstBuyer.final_approval_date));
                    }

                    setIsFinalized(true);
                } else {
                    getBuyerList1(oData).then(function (res) {
                        try {
                            if (res?.data?.data?.res && Array.isArray(res.data.data.res) && res.data.data.res.length > 0) {
                                const aInfo = res.data.data.res;
                                setErrMsg('');
                                setAssetInfo(aInfo[0]);
                                //setBuyerNameOptions(aInfo);

                                // Ensure "Select Buyer" is default
                                setSelectedBuyer("");
                                setBuyerNo("");

                            } else {
                                setAssetInfo({});
                                //setBuyerNameOptions([]);
                                setSelectedBuyer("");
                                setBuyerNo("");
                                setErrMsg('DIN no not found');
                            }
                        } catch (error) {
                            console.error('Error processing response:', error);
                            setAssetInfo({});
                            setBuyerNameOptions([]);
                            setSelectedBuyer("");
                            setBuyerNo("");
                            setErrMsg('Error processing DIN data');
                        }
                    }).catch((error) => {
                        console.error('Error fetching buyer list:', error);
                        setAssetInfo({});
                        setBuyerNameOptions([]);
                        setSelectedBuyer("");
                        setBuyerNo("");
                        setErrMsg('Error fetching buyer list');
                    });
                }
            }).catch((err) => {
                console.error('Error fetching DIN details:', err);
                setErrMsg('Error fetching DIN details');
                resetAssetDisposalInfo();
                setIsFinalized(false);
            });
        }
    };

    const fetchBuyerQuotedPrice = (buyerName) => {
        if (!buyerName) {
            setBuyer('');
            setErrMsg('Please select a buyer');
            return;
        }

        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'din_no': dinno, 'buyer_name': buyerName },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        let oData = { 'token': EncryptData };

        getBuyerQuotedPrice(oData).then((res) => {

            const responseArray = res?.data?.data?.res || res?.data?.res; // Handle possible structure changes

            if (Array.isArray(responseArray) && responseArray.length > 0) {
                const quotedPrice = responseArray[0]?.total_buyer_price_quoted ?? "N/A";

                setBuyer(quotedPrice);
                setErrMsg('');
            } else {
                setBuyer('');
                setErrMsg('Quoted Price Not found');
            }
        }).catch((error) => {
            setBuyer('');
            setErrMsg('Error fetching quoted price');
        });
    };

    const fetchBuyerQuotedPriceSingle = async (tag, buyerName) => {
        if (!buyerName || !tag) {
            console.error("Missing buyerName or tag:", { buyerName, tag });
            return;
        }

        const requestData = {
            'param_data': { 'din_no': dinno, 'buyer_name': buyerName, 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        };

        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify(requestData), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        try {
            const res = await getBuyerQuotedPriceSingle(oData);

            //Check if response has nested `data.data.res`
            const responseArray = res.data?.data?.res || res.data?.res;

            if (!Array.isArray(responseArray)) {
                console.error(`Unexpected API Response format for ${tag}:`, res);
                return;
            }

            if (responseArray.length > 0 && responseArray[0].buyer_price_quoted !== undefined) {
                const priceQuoted = responseArray[0].buyer_price_quoted;

                setQuotedPrices(prev => {
                    const updatedPrices = { ...prev, [tag]: priceQuoted };
                    return updatedPrices;
                });
            } else {
                setQuotedPrices(prev => ({
                    ...prev,
                    [tag]: 'N/A'
                }));
            }
        } catch (error) {
            console.error(`Error fetching quoted price for ${tag}:`, error);
            setQuotedPrices(prev => ({
                ...prev,
                [tag]: 'Error'
            }));
        }
    };

    const handleFormSubmitFinal = (e) => {
        e.preventDefault();
        var valid_Name1 = true;

        if (dealPriceType  === "Manual") {
            // Validate each tag’s sale price
            const errors = {};
            selectedTags.forEach(tag => {
                if (!salePrices[tag] || isNaN(salePrices[tag]) || Number(salePrices[tag]) <= 0) {
                    errors[tag] = "Final sale price is required and must be a positive number.";
                    valid_Name1 = false;
                } else if (!/^\d+(\.\d{1,2})?$/.test(salePrices[tag])) {
                    errors[tag] = "Enter a valid numeric value (up to 2 decimal places).";
                    valid_Name1 = false;
                }
            });
            setSalePriceErrors(errors);
        }

        if (!(buyer) && buyer !== 0) {
            buyerError('Final sale price is required');
            valid_Name1 = false;
        } else {
            buyerError('');
        }
        if (!(quotedReceivedDate) && quotedReceivedDate !== 0) {
            setQuotedReceivedDateError('Quoted Received Date is required');
            valid_Name1 = false;
        } else {
            setQuotedReceivedDateError('');
        }
        if (!(finalApprovalDate) && finalApprovalDate !== 0) {
            setFinalApprovalDateError('Quoted Approval Date is required');
            valid_Name1 = false;
        } else {
            setFinalApprovalDateError('');
        }
        if (!(finalApprovalBy) && finalApprovalBy !== 0) {
            setFinalApprovalByError('Final approval by is required');
            valid_Name1 = false;
        } else {
            setFinalApprovalByError('');
        }
        if (!selectedBuyer) {
            buyerError('Buyer is required');
            valid_Name1 = false;
        } else {
            buyerError('');
        }
        if (!buyerNameOptions) {
            setErrBuyerNameOptions('Buyer name is required');
            valid_Name1 = false;
        } else {
            setErrBuyerNameOptions('');
        }

        if (valid_Name1) {
            //alert('test1');
            saveFinalDeal(); //submit form
        } else {
            return false;
        }
        // Perform form submission logic here
    };

    const saveFinalDeal = function () {
        try {
            //alert(salePrices);
            var obj = {
                'tag': selectedTags,
                'din_no': assetInfo.din_no,
                'buyer_no': buyer_no,
                'buyer_name': selectedBuyer,
                'deal_price_type':
                    dealPriceType === "Quoted" ? "Quoted" :
                        dealPriceType === "Automatic" ? "Automatic" :
                            "Manual"
                ,
                //'disposal_type': disposal === "Partial" ? "Partial" : "Full",
                //'buyer_final_price': dealPriceType === "Quoted" ? salePrices : finalSalePrice, // Send correct data
                'buyer_final_price': salePrices,
                'tags_total_price': buyer,
                'buyer_quote_received_date': quotedReceivedDate ? getFormatedDate(quotedReceivedDate) : '',
                'final_approval_date': finalApprovalDate ? getFormatedDate(finalApprovalDate) : '',
                'final_approval_by': finalApprovalBy,
                'gen_ref_no': updatedDinNo,
            };

            let EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    'param_data': obj,
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            let oData = {'token': EncryptData};

            saveFinalisedDeal(oData).then((res) => {
                if (res.data.errors && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetAssetDisposalInfo();
                    setFormSubmitted(true);
                    getTagInfo();

                    const userChoice = window.confirm("Do you want to generate Gate Pass for this transaction?");
                    if (userChoice) {
                        handleGenerateNow();
                    } else {
                        handleGenerateLater();
                    }
                }
            });

        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                //console.log(err);
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('Data already exists');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    };

    const handleGenerateNow = () => {
        const dinNoToEncrypt = assetInfo.din_no;
        const encryptedDinNo = CryptoJS.AES.encrypt(
            JSON.stringify(dinNoToEncrypt),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();
        navigate(`/generate-gate-pass-din?dinNo=${encodeURIComponent(encryptedDinNo)}`);
    };

    const handleGenerateLater = () => {
        //console.log("Gate Pass generation deferred.");
        navigate(0); // Reload the current page
    };

    const handleDisposal = (event) => {
        setDisposal(event.target.value);
        setDealPriceType(""); // Reset deal price type when disposal type changes
    };

    const handleDealPrice = (event) => {
        setDealPriceType(event.target.value);
    };

    const handleCheckboxChange = (tag) => {
        if (disposal === "Full") return;  // Prevent manual changes when disposal is Full

        setSelectedTags((prevSelected) =>
            prevSelected.includes(tag)
                ? prevSelected.filter((t) => t !== tag) // Uncheck
                : [...prevSelected, tag] // Check
        );
    };

    const handlePrevClick = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior
        setActiveTab(activeTab - 1);
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h5>Finalize Deal</h5>
                </div>
            </div>


            {success ? (<div className="alert alert-success" role="alert"><i
                className="bi bi-check-circle-fill"></i> {success}</div>) : (errMsg ? (
                <div className="alert alert-danger" role="alert"><i
                    className="bi bi-exclamation-triangle-fill"></i> {errMsg}</div>) : (''))}


            <div className="tab-content">

                <div className={`tab-pane ${activeTab === 0 ? 'active' : ''}`}>

                    <div className='row '>
                        <div className='col-12'>&nbsp;</div>
                        <div className='row'>
                            <div className='col-10'></div>
                            <div className='col-2'></div>
                        </div>
                        : <div className='row'>
                        <div className='col'><h5 className='align-right'>DIN No. </h5></div>

                        <div className='col'>
                            <input onChange={function (event) {
                                setDinno(event.target.value)
                            }} inputValue={assetInfo.tag} type="text"
                                   setInputValue={setDinno}
                                   setErrorMsg={setdinNoError}
                                   className="form-control"
                                   placeholder='Enter DIN No.'/>
                            <p className='invalid-feedback'>{dinnoError}</p></div>
                        <div className='col'>
                            <button onClick={getTagInfo} className='btn btn-info btn-md'><i
                                className="bi bi-search"></i> Search
                            </button>
                        </div>
                    </div>

                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldText
                                label="DIN No."
                                placeholder="DIN No."
                                inputValue={assetInfo?.din_no}// Use optional chaining here
                                readOnly="readonly"
                            />
                        </div>
                        <div className="col-6">
                            <FromFieldText
                                readOnly="readonly"
                                label="DIN Created Date"
                                inputValue={assetInfo?.created_at ? getFormatedDate(assetInfo.created_at) : ''} // Use optional chaining here
                            />
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col">
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-6">
                                        <label> Type of Finalize </label>
                                        <span className="star error">  </span>
                                    </div>
                                    <div className="col-md-6">
                                        <select onChange={handleDisposal} name="childFlagging"
                                                id="childFlagging"
                                                className="form-select form-select-sm">
                                            <option value="">Select type of Disposal</option>
                                            <option value="Full"
                                                    selected={disposal === "Full" ? "selected" : ''}>Bulk
                                            </option>
                                            <option value="Partial"
                                                    selected={disposal === "Partial" ? "selected" : ''}>Individuals
                                            </option>
                                        </select>
                                        <span className="invalid-feedback">{ErrDisposal} </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <label>Final Price Type</label>
                                        <span className="star error"></span>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            onChange={handleDealPrice}
                                            value={dealPriceType}
                                            className="form-select form-select-sm"
                                        >
                                            <option value="">Select Final Price Type</option>
                                            <option value="Quoted">As per Quote</option>
                                            <option value="Manual">Update Now Individually</option>
                                            <option value="Automatic">Update Now Single Price for selected TAGs</option>
                                        </select>
                                        <span className="invalid-feedback d-block">{ErrDealPriceType}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-5">&nbsp;</div>
                        <div className="col-2">
                            <form name="" onSubmit={handleFormSubmit}>
                                <button className="btn btn-primary btn-md"> Next <i
                                    className="bi bi-arrow-right-short"></i>
                                </button>
                            </form>
                        </div>
                        <div className="col-5">&nbsp;</div>
                    </div>

                </div>

                <div className={`tab-pane ${activeTab === 1 ? 'active' : 'hidden'}`}>

                    <div className="row mt-4">
                        <div className="col-5">
                            <FromFieldText
                                label="DIN No."
                                placeholder="DIN No."
                                inputValue={assetInfo?.din_no} // Use optional chaining here
                                readOnly="readonly"
                            />
                        </div>
                        <div className="col-3">
                            <FromFieldText
                                readOnly="readonly"
                                label="DIN Created Date"
                                inputValue={assetInfo?.created_at ? getFormatedDate(assetInfo.created_at) : ''}
                            />
                        </div>
                        <div className="col-4">
                            <FromFieldText
                                label="Type of Finalize"
                                inputValue={disposal}
                                setInputValue={setDisposal}
                                setErrorMsg={ErrDisposal}
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <table className="table table-bordered">
                            <thead className="text-center">
                            <tr>
                                <th>Sl #</th>
                                <th>TAG No</th>
                                <th>Quote Received Status</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <tbody className="text-center">
                            {tagList.length > 0 ? (
                                tagList.map(({tag, sub_status, buyerCount}, index) => (
                                    <tr key={index}>
                                        <td>
                                            {sub_status !== "Disposal Initiated" && sub_status !== "Sale Completed" && ( // Hide checkbox if Disposal Initiated
                                                <input
                                                    type="checkbox"
                                                    name={`selectedTag[${index}]`}
                                                    checked={disposal === "Full" || selectedTags.includes(tag)} // Ensure checked for Full disposal
                                                    onChange={() => handleCheckboxChange(tag)}
                                                    disabled={disposal === "Full"} // Prevent manual changes in Full disposal
                                                />
                                            )}
                                        </td>
                                        <td>{tag}</td>
                                        <td>{sub_status === "Disposal Initiated" ? "No Quote Received" : sub_status}</td>
                                        <td>
                                        {buyerCount === 0
                                                ? "No Quote Received"
                                                : `Quote Received from ${buyerCount} Buyers`}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">No Tags Available</td>
                                    {/* Ensure colspan matches table headers */}
                                </tr>
                            )}

                            </tbody>
                        </table>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <form name="" onSubmit={handlePrevClick}>
                                <button className="btn btn-secondary btn-md float-end"><i
                                    className="bi bi-arrow-left"></i> Back
                                </button>
                            </form>
                        </div>

                        <div className="col-6">
                            <form name="" onSubmit={!allTagsFinalized ? handleFormSubmit1 : (e) => e.preventDefault()}>
                                {disposal === "Full" && tagList.every(({buyerCount}) => buyerCount === 0) && (
                                    <p className="text-danger">Quote not received for all TAGs.</p>
                                )}

                                <button
                                    className="btn btn-primary btn-md"
                                    disabled={allTagsFinalized || (disposal === "Full" && tagList.every(({buyerCount}) => buyerCount === 0))}
                                >
                                    {allTagsFinalized ? "Already Finalized" : "Next"} <i className="bi bi-arrow-right-short"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                <div className={`tab-pane ${activeTab === 2 ? 'active' : 'hidden'}`}>

                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldText
                                label="DIN Number"
                                placeholder="DIN Number"
                                inputValue={assetInfo.din_no ? assetInfo.din_no : ''}
                                readOnly="readonly"
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="selectBuyer">Select Buyer Name</label>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        id="selectBuyer"
                                        className="form-select"
                                        onChange={handleBuyerDetails}
                                        required
                                        value={selectedBuyer}
                                    >
                                        <option value="">Select Buyer</option>
                                        {buyerNameOptions.length > 0 ? (
                                            buyerNameOptions.map((option, index) => (
                                                <option key={option.buyer_no || `buyer_${index}`}
                                                        value={option.buyer_name}>
                                                    {option.buyer_name.charAt(0).toUpperCase() + option.buyer_name.slice(1).toLowerCase()}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="">No Data</option>
                                        )}
                                    </select>
                                    <span className="invalid-feedback"> {ErrBuyerNameOptions} </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldText
                                label="Price Quoted"
                                inputValue={buyer}
                                setInputValue={setbuyer}
                                setErrorMsg={buyerError}
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldDate
                                label="Final Sale Date"
                                placeholder="Final Sale Date"
                                inputValue={quotedReceivedDate}
                                setInputValue={setQuotedReceivedDate}
                                setErrorMsg={quotedReceivedDateError}
                            />
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldDate
                                label="Final Approval Date"
                                placeholder="Final Approval Date"
                                inputValue={finalApprovalDate}
                                setInputValue={setFinalApprovalDate}
                                setErrorMsg={finalApprovalDateError}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldText
                                label="Final Approval By"
                                placeholder="Final Approval By"
                                inputValue={finalApprovalBy}
                                setInputValue={setFinalApprovalBy}
                                setErrorMsg={finalApprovalByError}
                            />
                        </div>

                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <FromFieldText
                                label="Gen Ref No"
                                inputValue={updatedDinNo}
                                readOnly="readonly"
                            />
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>Tag</th>
                                    <th>Buyer Quoted Price</th>
                                    <th>Final Sale Price W/o GST</th>
                                </tr>
                                </thead>
                                <tbody>
                                {selectedTags.length > 0 ? (
                                    selectedTags.map(tag => (
                                        <tr key={tag}>
                                            <td>{tag}</td>
                                            <td>
                                                {quotedPrices[tag] !== undefined && quotedPrices[tag] !== null ? (
                                                    quotedPrices[tag]
                                                ) : (
                                                    "Fetching..."
                                                )}
                                            </td>
                                            <td>
                                                {dealPriceType === "Quoted" || dealPriceType === "Automatic" ? (
                                                    <input
                                                        type="text"
                                                        value={quotedPrices[tag] || ""}
                                                        className="form-control"
                                                        readOnly
                                                    />
                                                ) : (
                                                    <input
                                                        type="text"
                                                        value={salePrices[tag] || ""}
                                                        onChange={(e) => handleSalePriceChange(tag, e.target.value)}
                                                        className="form-control"
                                                    />
                                                )}
                                                {salePriceErrors[tag] && (
                                                    <p className="text-danger">{salePriceErrors[tag]}</p>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No Tags Selected</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-6">
                            <div className='text-center'>
                                <div className="d-flex justify-content-center">
                                    <div className="col-md-4">
                                        <form name="" onSubmit={handlePrevClick}>
                                            <button className="btn btn-secondary btn-md float-end"><i
                                                className="bi bi-arrow-left"></i> Back
                                            </button>
                                        </form>
                                    </div>
                                    <div className="col-md-6 text-center">
                                        {!formSubmitted && (
                                            <form name="" onSubmit={handleFormSubmitFinal}>
                                                <button
                                                    className="btn btn-primary btn-md"
                                                    disabled={formSubmitted || isFinalized} // Disable if already finalized
                                                >
                                                    {isFinalized ? 'Already Finalized' : 'Submit'}
                                                </button>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>


            </div>


        </div>
    )
}

export default SingleFinalizeDeal;